import { defineStore } from 'pinia';
import { type Observable, tap } from 'rxjs';
import { computed, ref } from 'vue';

import { mapBy, mapById } from '@silae/helpers/structures';
import type { PrettyOrganization } from '~/domain';
import { type OrganizationDto, fetchOrganization } from '~/services';
import { getPlanLabel } from '~/utils/organization.helpers';

export const useOrganizationStore = defineStore('org-store', () => {
	const organization = ref<PrettyOrganization>();
	const orgId = computed(() => organization.value?.id);
	const orgProfileMap = computed(() => mapById(organization.value?.organizationProfiles ?? []));
	const orgExpenseWorkflowStepsMap = computed(() => mapBy(organization.value?.expensesWorkflowSteps ?? [], 'metaState'));
	const orgContextLoaded = computed(() => !!organization.value);

	const fetchOrg = (orgId: string): Observable<OrganizationDto> => {
		return fetchOrganization(orgId).pipe(
			tap(org => {
				organization.value = {
					...org,
					planLabel: getPlanLabel(org.plan)
				};
			})
		);
	};

	const reset = () => {
		organization.value = null;
	};

	return {
		/** Computed */
		organization,
		orgContextLoaded,
		orgExpenseWorkflowStepsMap,
		orgId,
		orgProfileMap,

		/** Functions */
		fetchOrg,
		reset
	};
});
